import { useState } from 'react'
import UploadAnImagePage from './UploadAnImagePage'
import WantToInstertAPicturePage from './WantToInstertAPicturePage'
import ImageUploadedPage from './ImageUploadedPage'
import { useSelector } from 'react-redux'
import { resolveAvatarImage } from '../../../services/functions'
import SelectAnAvatarPage from './SelectAnAvatarPage'

const AvatarPages = props => {
  const avatar = useSelector(state => state.initialConfig.avatar)
  const [pageSelected, setPageSelected] = useState(() => {
    if (!avatar) return 1

    const raw = String(avatar ?? '').trim()
    const resolved = resolveAvatarImage(raw)
    const isDefaultAvatar = !!resolved && resolved !== raw

    return isDefaultAvatar ? 4 : 2
  })

  if (pageSelected === 1) return <WantToInstertAPicturePage {...props} setPageSelected={setPageSelected} />
  if (pageSelected === 2) return <UploadAnImagePage {...props} setPageSelected={setPageSelected} />
  if (pageSelected === 3) return <ImageUploadedPage {...props} setPageSelected={setPageSelected} />
  if (pageSelected === 4) return <SelectAnAvatarPage {...props} setPageSelected={setPageSelected} />
}

export default AvatarPages
